import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { Decimal } from 'decimal.js';
import { Subscription, map } from 'rxjs';

import { PickId } from '../../../../../core/picks/pick-id';
import { BetslipSummaryService } from '../../../../summary/services/betslip-summary.service';

@Component({
    selector: 'bs-betslip-over-ask-pick-possible-winnings',
    template: `
        <ng-container>
            <span>{{ messages.possibleWinnings }}:</span>
            <span>{{ possibleWinnings | bsCurrency: true }}</span>
        </ng-container>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BetslipOverAskPickPossibleWinningsComponent implements OnInit, OnDestroy {
    @Input() pickId: PickId;
    possibleWinnings: Decimal | null;
    readonly messages: {
        possibleWinnings: string;
        possibleWinningsNet: string;
    };

    private possibleWinningsSubscription: Subscription;

    constructor(
        private summaryService: BetslipSummaryService,
        private changeDetector: ChangeDetectorRef,
        siteCore: Sitecore,
    ) {
        this.messages = {
            possibleWinnings: siteCore.betslip.messages.PossibleWinnings,
            possibleWinningsNet: siteCore.betslip.messages.PossibleWinningsNet,
        };
    }

    ngOnInit(): void {
        this.possibleWinningsSubscription = this.summaryService
            .getOverAskSummary$()
            .pipe(
                map((value) => {
                    const betslipSummary = value.offer[1];
                    const summary = betslipSummary.slipSummaries.find((s) => {
                        const pickIds = Object.keys(s.slip.slipPicks);

                        return pickIds.length === 1 && pickIds[0] === this.pickId.toString();
                    });
                    if (!summary) {
                        return null;
                    }

                    return summary.possibleWinnings;
                }),
            )
            .subscribe((winnings) => {
                this.possibleWinnings = winnings;
                this.changeDetector.markForCheck();
            });
    }

    ngOnDestroy(): void {
        this.possibleWinningsSubscription?.unsubscribe();
    }
}
